import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  signal,
  WritableSignal
} from '@angular/core';
import { LMContextService } from '@app/services';
import { LMFacadeService } from '@components/facade/services';
import { LMThemeService } from '@banner/lm-theme.service';


@Component({
  selector:    'lm-facade-business-object',
  standalone: false,
  templateUrl: './lm-facade-business-object.component.html',
  styleUrl: './lm-facade-business-object.component.scss',
})
export class LMFacadeBusinessObjectComponent implements OnInit, AfterViewInit, OnDestroy {
  private defaultTemplateDetail: LMFacadeDetailRequest = {
    type: 'undefined',
  };

  private templates:Array<LMFacadeReportTemplate> = [];
  private listTemplates:Array<LMFacadeReportTemplate> = [];

  initials = signal('');
  color = signal('');
  facadeDetailRequest: WritableSignal<LMFacadeDetailRequest> = signal(this.defaultTemplateDetail);
  moduleCardWidth = signal(0);

  @Input() options: LMFacadeBusinessObjectOptions | undefined;
  @Output() closeBo: EventEmitter<boolean> = new EventEmitter<boolean>();

  businessObject: LMBusinessObject | undefined;
  businessClassFacade: LMBusinessClassFacade | undefined;
  selectedTemplate: LMFacadeReportTemplate | undefined;
  selectedReportType: LMFacadeReportType = 'transaction';
  selectedReportFilter: LMTemplateCategory = 'allLists';
  emptySearchTitle = Soho.Locale.translate('ReportCatalogEmptySearchTitle');
  emptySearchInfo = Soho.Locale.translate('ReportCatalogEmptySearchMessage');

  public displayedTemplates: Array<LMFacadeReportTemplate> = [];
  public templateGridOptions: SohoDataGridOptions | undefined;
  public viewTilesSelected = true;
  public viewGridSelected = false;

  reportTypes: Array<LMFacadeReportTypeOption> = [];

  public quickFilter: Array<LMFacadeReportTemplateFilter> = [
    { displayName: Soho.Locale.translate('ReportCatalogFavoritesTab'), option: 'favorite', selected: false },
    { displayName: Soho.Locale.translate('ReportCatalogMyReports'), option: 'myReports', selected: false },
    { displayName: Soho.Locale.translate('ReportCatalogOrganizationReports'), option: 'myOrgReports', selected: false },
    { displayName: Soho.Locale.translate('DeliveredReports'), option: 'myDeliveredReports', selected: false },
    { displayName: Soho.Locale.translate('All'), option: 'allLists', selected: false },
  ];

  private readonly actorId: string;


  private ro: ResizeObserver | undefined;
  private moduleContent: Element | undefined;
  private currentWidth = 0;

  constructor(
    private lmContextService: LMContextService,
    private lmFacadeService: LMFacadeService,
    protected lmThemeService: LMThemeService,
    private element: ElementRef
  ) {
    this.actorId = this.lmContextService.getActorId();
  }

  ngOnInit() {
    if (this.options) {
      this.businessObject = JSON.parse(JSON.stringify(this.options.businessObject));  // Maria creating a new object so this component can change the module|category
      this.color.set(this.lmFacadeService.getModuleColor(this.options.businessObject.moduleTag));
      this.businessClassFacade = this.options.businessClassFacade;
      this.buildReportTypes(this.options.businessObject.moduleTag, this.businessClassFacade);
      this.templates = this.options.templates;
      this.listTemplates = this.options.listTemplates;
      // this.displayedTemplates = [ ...this.templates, ...this.listTemplates ];
      this.displayedTemplates = this.templates;
    }

    this.buildModuleGrid();
    this.moduleContent = this.element.nativeElement.querySelector('.lm-module-facade-bc-templates');

    if (this.moduleContent) {

      this.ro = new ResizeObserver(() => {
        if (this.moduleContent) {
          const newWidth = this.moduleContent.clientWidth;
          if (newWidth !== this.currentWidth) {
            this.currentWidth = newWidth;
            const newCardWidth = (this.currentWidth/3.2) - 10;
            this.moduleCardWidth.set(newCardWidth);
          }
        }
      });

      this.ro.observe(this.moduleContent);
    }
  }

  ngAfterViewInit() {
    this.onReportTypeClick('transaction');
  }

  ngOnDestroy() {
    if (this.ro && this.moduleContent) {
      this.ro.unobserve(this.moduleContent);
    }
  }

  private buildReportTypes(moduleTag: string, facade: LMBusinessClassFacade) {
    this.reportTypes.push( {
      type: 'transaction', title: Soho.Locale.translate('Facade_ReportTypeLive_Title'), description: Soho.Locale.translate('Facade_TransactionReportTypeDescription'), icon: 'lightning' });


    if (this.lmFacadeService.isColumnarReportsEnabled(moduleTag, facade)) {
      this.reportTypes.push(
          { type: 'columnar', title: Soho.Locale.translate('Facade_ReportTypeColumnar_Title'), description: Soho.Locale.translate('Facade_ColumnarReportTypeDescription'), icon: 'line-bar-chart' },);
    }
    // pivot not supported for OCT 2026
    // if (this.lmFacadeService.isCubeViewReportsEnabled(moduleTag, facade)) {
    //   this.reportTypes.push(
    //       { type: 'analytic', title: Soho.Locale.translate('Facade_ReportTypePivot'), description: Soho.Locale.translate('Facade_CubeReportTypeDescription'), icon: 'line-chart' },);
    // }
  }

  closeBOExplorer(): void {
    this.closeBo.emit(true);
  }

  onQuickFilterClick(option: LMTemplateCategory): void {
    this.clearSelection();
    if (this.templates) {
      this.selectedReportFilter = option;
      const allTemplates = [ ...this.templates, ...this.listTemplates ];

      if (this.selectedReportFilter.length === 0) {
        this.displayedTemplates = allTemplates;
        return;
      }
      this.displayedTemplates = allTemplates.filter((template: LMFacadeReportTemplate) => {
          if (!this.isCurrentReportType(template)) {
            return false;
          }

          switch (this.selectedReportFilter) {
            case 'favorite':
              return template.favorite;
            case 'myReports':
              return template.owner === this.actorId;
            case 'myOrgReports':
              return template.userFolder ? template.userFolder.length > 0 : false;
            case 'myDeliveredReports':
              // if (template.type === 'nonReport') {
              //   return false;
              // } else {
                return template.userFolder ? template.userFolder.length === 0 : true;
              // }
            case 'allLists':
              return true; //template.type === 'nonReport';
            default:
              return false;
          }
      });
    }
  }

  private isCurrentReportType(template: LMFacadeReportTemplate): boolean {
    return template.dataSource === this.selectedReportType;
  }

  viewClicked(view: 'grid' | 'tiles'): void {
    this.clearSelection();
    this.viewGridSelected = this.viewTilesSelected = false;
    if (view === 'grid')
      this.viewGridSelected = true;
    else
      this.viewTilesSelected = true;
  }

  onTemplateClicked(template: LMFacadeReportTemplate) {
    this.selectedTemplate = template;
    this.facadeDetailRequest.set( { type: 'template', detail: { template: template } });
  }

  onReportTypeClick(reportType: LMFacadeReportType) {
    this.selectedReportType = reportType;
    this.selectedTemplate = undefined;

    if (this.businessObject && this.businessClassFacade) {
      const detail: LMFacadeBusinessClassDetailRequest = {
        businessClass: this.businessObject.businessClass,
        moduleTag: this.businessObject.moduleTag,
        type: reportType,
        facade: this.businessClassFacade
      };

      this.facadeDetailRequest.set( { type: 'businessClass', detail: detail } );
    }

    if (this.selectedReportFilter) {
      this.onQuickFilterClick(this.selectedReportFilter);
    } else {
      this.onQuickFilterClick('allLists');
    }
  }

  private clearSelection() {
    this.selectedTemplate = undefined;
  }

  onRowClicked(event: SohoDataGridRowClicked) {
    if (this.displayedTemplates) {
      const selectedTemplateString = event.item.reportName;
      const selectedTemplate = this.displayedTemplates.find((temp: LMFacadeReportTemplate) => temp.reportName === selectedTemplateString);
      if (selectedTemplate)
        this.onTemplateClicked(selectedTemplate);
    }
  }

  private buildModuleGrid() {
    const headerColumns: SohoDataGridColumn[] = [
      {
        id:             'reportName',
        name:           Soho.Locale.translate('ListPersonalizationReportNameLabel'),
        field:          'reportName',
        sortable:       true,
        searchable:     true,
        filterType:     'text',
        singleline:     true,
      },
      {
        id:             'description',
        name:           Soho.Locale.translate('Description'),
        field:          'description',
        sortable:       false,
        searchable:     true,
        filterType:     'text',
        singleline:     false,
        width:          25,
        formatter:      Soho.Formatters.Ellipsis,
      },
      {
        id:             'category',
        name:           Soho.Locale.translate('ReportCatalogCategory'),
        field:          'categoryName',
        sortable:       true,
        filterType:     'text',
        singleline:     true,
      },
      {
        id:             'subcategory',
        name:           Soho.Locale.translate('ReportCatalogSubcategory'),
        field:          'subCategoryName',
        sortable:       true,
        filterType:     'text',
        singleline:     true,
      },
      {
        id:             'owner',
        name:           Soho.Locale.translate('Owner'),
        field:          'owner',
        sortable:       false,
        searchable:     true,
        filterType:     'text',
        singleline:     false,
      },
    ];

    this.templateGridOptions = <SohoDataGridOptions>{
      emptyMessage:         { title: Soho.Locale.translate('Facade_ReportTemplatesEmptyMessage') },
      columns:              headerColumns,
      selectable:           'single',
      editable:             false,
      paging:               true,
      showDirty:            false,
      rowHeight:            'short',
      clickToSelect:        true,
      columnSizing:         'header',
      enableTooltips:       true,
      stickyHeader:         false,
      filterWhenTyping:     false,
      isList:               true,
      filterDisabled:       false,
      showPageSizeSelector: true,
      filterable:           true,
      pagesize:             10,
      spacerColumn:         true
    };
  }
}
